import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api/axios';
import { useToast } from '../context/ToastContext';

const UniversityQuestionGeneration = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  // State management
  const [loading, setLoading] = useState(false);
  console.log(loading)
  const [generating, setGenerating] = useState(false);
  const [universityPools, setUniversityPools] = useState([]);
  const [selectedPool, setSelectedPool] = useState(null);
  const [poolDetails, setPoolDetails] = useState(null);
  console.log(poolDetails)
  const [templateQuestions, setTemplateQuestions] = useState([]);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [selectedSubQuestion, setSelectedSubQuestion] = useState(null);
  // 3rd level: when the selected sub-question itself has nested sub-parts (e.g. a.i, a.ii)
  const [selectedSubPart, setSelectedSubPart] = useState(null);

  // Form state - pre-filled from pool
  const [paperForm, setPaperForm] = useState({
    subject: '',
    topic: '',
    chapters: '',
    language: 'english'
  });

  const [variationForm, setVariationForm] = useState({
    num_variations: 4
  });

  // PDF upload state
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfValidation, setPdfValidation] = useState(null);
  const [validatingPdf, setValidatingPdf] = useState(false);
  const [showRelevanceWarning, setShowRelevanceWarning] = useState(false);

  // Progress modal state
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [generationProgress, setGenerationProgress] = useState({
    current: 0,
    total: 0,
    stage: ''
  });

  // Question tracking state
  // const [completedQuestions, setCompletedQuestions] = useState(new Set());
  // const [completedSubQuestions, setCompletedSubQuestions] = useState(new Set());
  // const [nextAvailable, setNextAvailable] = useState({ nextQuestion: null, nextSubQuestion: null, allCompleted: false });

  // Helper function to get next available question/sub-question
  // const getNextAvailableSelection = useCallback((questions, completed, completedSubs) => {
  //   for (let question of questions) {
  //     const hasSubQuestions = (question.sub_questions || question.subquestions)?.length > 0;
      
  //     if (hasSubQuestions) {
  //       const subQuestions = question.sub_questions || question.subquestions;
  //       for (let subQ of subQuestions) {
  //         const key = `${question.question_number}-${subQ.sub_number}`;
  //         if (!completedSubs.has(key)) {
  //           return {
  //             nextQuestion: question,
  //             nextSubQuestion: subQ,
  //             allCompleted: false
  //           };
  //         }
  //       }
  //     } else {
  //       if (!completed.has(question.question_number)) {
  //         return {
  //           nextQuestion: question,
  //           nextSubQuestion: null,
  //           allCompleted: false
  //         };
  //       }
  //     }
  //   }
    
  //   return {
  //     nextQuestion: null,
  //     nextSubQuestion: null,
  //     allCompleted: true
  //   };
  // }, []);

  // // Initialize with first question only available
  // const initializeQuestionTracking = useCallback((questions) => {
  // Initialize with first question only available
  // const initializeQuestionTracking = useCallback((questions) => {
  //   setCompletedQuestions(new Set());
  //   setCompletedSubQuestions(new Set());
    
  //   if (questions.length > 0) {
  //     const next = getNextAvailableSelection(questions, new Set(), new Set());
  //     setNextAvailable(next);
      
  //     // Auto-select first question
  //     if (next.nextQuestion) {
  //       setSelectedQuestion(next.nextQuestion);
  //       setSelectedSubQuestion(next.nextSubQuestion);
  //     }
  //   }
  // }, [getNextAvailableSelection]);

  // // Mark question as completed and move to next
  // const markQuestionCompleted = useCallback((questionNumber, subQuestionNumber) => {
  //   setCompletedQuestions(prevCompleted => {
  //     const newCompleted = new Set(prevCompleted);
  //     if (!subQuestionNumber) {
  //       newCompleted.add(questionNumber);
  //     }
  //     return newCompleted;
  //   });
    
  //   setCompletedSubQuestions(prevCompletedSubs => {
  //     const newCompletedSubs = new Set(prevCompletedSubs);
  //     if (subQuestionNumber) {
  //       const key = `${questionNumber}-${subQuestionNumber}`;
  //       newCompletedSubs.add(key);
  //     }
  //     return newCompletedSubs;
  //   });
  // }, []);

  // Update next available when completed questions change
  // useEffect(() => {
  //   if (templateQuestions.length > 0) {
  //     const next = getNextAvailableSelection(templateQuestions, completedQuestions, completedSubQuestions);
  //     setNextAvailable(next);
      
  //     // Auto-select next if available
  //     if (next.nextQuestion && !selectedQuestion) {
  //       setSelectedQuestion(next.nextQuestion);
  //       setSelectedSubQuestion(next.nextSubQuestion);
  //     }
  //   }
  // }, [completedQuestions, completedSubQuestions, templateQuestions, getNextAvailableSelection, selectedQuestion]);

  const fetchUniversityPools = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await API.get('/university-pool-examiner/available-pools');
      console.log('📥 University pools fetched:', data);
      setUniversityPools(data.pool_papers || []);
    } catch (error) {
      console.error('Error fetching pools:', error);
      showToast('Failed to load university pools', 'error');
    } finally {
      setLoading(false);
    }
  }, [showToast]);

  useEffect(() => {
    fetchUniversityPools();
  }, [fetchUniversityPools]);

  const handlePoolSelect = async (poolId) => {
    try {
      setLoading(true);
      setSelectedPool(poolId);
      
      const pool = universityPools.find(p => p.pool_paper_id === poolId);
      console.log('📋 Selected pool details:', pool);
      setPoolDetails(pool);

      // Pre-fill form with pool data
      setPaperForm(prev => ({
        ...prev,
        subject: pool?.subject_name || '',
        topic: pool?.paper_title || '',
        language: pool?.language || 'english'
      }));

      // Load template questions
      if (pool?.template_id) {
        await loadTemplateQuestions(pool.template_id);
      }

      setSelectedQuestion(null);
      setSelectedSubQuestion(null);
      setSelectedSubPart(null);
    } catch (error) {
      console.error('Error loading pool:', error);
      showToast('Failed to load pool', 'error');
    } finally {
      setLoading(false);
    }
  };

  const loadTemplateQuestions = async (templateId) => {
    try {
      const { data } = await API.get(`/templates/${templateId}`);
      let questions = data.template?.questions || data.questions;
      
      if (typeof questions === 'string') {
        questions = JSON.parse(questions);
      }
      
      console.log('📋 Raw template questions:', questions);
      
      // Process questions to handle the exact API format
      const processedQuestions = (questions || []).map(q => {
        let subQuestions = [];
        
        // Map nested sub-parts (3rd level) of a sub-question, preserving their own fields.
        const mapSubParts = (sq, parentType) => {
          const parts = sq.subquestions || sq.sub_questions;
          if (!parts || !Array.isArray(parts)) return [];
          return parts.map(ssq => ({
            sub_number: ssq.sub_number || ssq.sub_question_number,
            question_type: ssq.question_type || sq.question_type || parentType || 'short_answer',
            marks: ssq.marks || 2,
            difficulty: ssq.difficulty || 'medium',
            difficulty_reason: ssq.difficulty_reason || '',
            sub_question_text: ssq.sub_question_text || ssq.question_text || ''
          }));
        };

        // Handle 'subquestions' (lowercase) format from API
        if (q.subquestions && Array.isArray(q.subquestions)) {
          subQuestions = q.subquestions.map(sq => {
            const subParts = mapSubParts(sq, q.question_type);
            return {
              sub_number: sq.sub_number,
              sub_question_number: sq.sub_number,
              full_question_number: `${q.question_number}.${sq.sub_number}`,
              question_type: sq.question_type || q.question_type || 'short_answer',
              marks: sq.marks || 2,
              difficulty: sq.difficulty || 'medium',
              difficulty_reason: sq.difficulty_reason || '',
              sub_question_text: sq.sub_question_text || '',
              has_subquestions: sq.has_subquestions !== undefined ? sq.has_subquestions : subParts.length > 0,
              subquestions: subParts
            };
          });
        } else if (q.sub_questions && Array.isArray(q.sub_questions)) {
          // Fallback for 'sub_questions' format
          subQuestions = q.sub_questions.map(sq => {
            const subParts = mapSubParts(sq, q.question_type);
            return {
              sub_number: sq.sub_number || sq.sub_question_number,
              sub_question_number: sq.sub_question_number || sq.sub_number,
              full_question_number: sq.full_question_number || `${q.question_number}.${sq.sub_number || sq.sub_question_number}`,
              question_type: sq.question_type || q.question_type || 'short_answer',
              marks: sq.marks || 2,
              difficulty: sq.difficulty || 'medium',
              difficulty_reason: sq.difficulty_reason || '',
              sub_question_text: sq.sub_question_text || sq.question_text || '',
              has_subquestions: sq.has_subquestions !== undefined ? sq.has_subquestions : subParts.length > 0,
              subquestions: subParts
            };
          });
        }
        
        return {
          question_number: q.question_number,
          question_type: q.question_type || 'short_answer',
          marks: q.marks || 5,
          question_text: q.question_text || '',
          difficulty: q.difficulty || 'medium',
          has_subquestions: q.has_subquestions !== undefined ? q.has_subquestions : subQuestions.length > 0,
          sub_questions: subQuestions
        };
      });
      
      console.log('📋 Final processed template questions:', processedQuestions);
      setTemplateQuestions(processedQuestions);
    } catch (error) {
      console.error('Error loading template questions:', error);
      showToast('Failed to load template questions', 'error');
    }
  };

  const handlePdfSelect = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    // Validate file type
    if (file.type !== 'application/pdf') {
      showToast('Only PDF files are allowed', 'error');
      return;
    }

    // Validate file size (50MB)
    if (file.size > 50 * 1024 * 1024) {
      showToast('File size exceeds 50MB limit', 'error');
      return;
    }

    setPdfFile(file);
    setPdfValidation(null); // Clear previous validation
    setShowRelevanceWarning(false);
    console.log(showRelevanceWarning)
    console.log('📄 PDF selected:', file.name, `(${(file.size / 1024 / 1024).toFixed(2)} MB)`);
  };

  const handlePdfRemove = () => {
    setPdfFile(null);
    setPdfValidation(null);
    setShowRelevanceWarning(false);
    console.log('🗑️ PDF removed');
  };

  const handleValidatePdf = async () => {
    if (!pdfFile || !paperForm.topic || !paperForm.subject) {
      showToast('Please upload a PDF and fill in topic/subject first', 'error');
      return;
    }

    try {
      setValidatingPdf(true);
      console.log('📤 Uploading PDF to File Search Store...');

      // Step 1: Upload PDF
      const formData = new FormData();
      formData.append('pdf', pdfFile);
      formData.append('topic', paperForm.topic);
      formData.append('subject', paperForm.subject);

      const { data: uploadData } = await API.post('/sub-questions/upload-pdf', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 90000
      });

      console.log('✅ PDF uploaded:', uploadData.fileMetadata.fileId);

      if (!uploadData.isNewUpload) {
        showToast('Using existing PDF file', 'info');
      }

      // Step 2: Validate relevance
      console.log('🔍 Validating PDF relevance...');
      const { data: validationData } = await API.post('/sub-questions/validate-pdf-topic-v2', {
        fileId: uploadData.fileMetadata.fileId,
        topic: paperForm.topic,
        subject: paperForm.subject,
        chapters: paperForm.chapters || ''
      }, {
        timeout: 90000
      });

      const validation = validationData.validation;
      console.log('✅ Validation complete:', validation);

      // Store validation results in component state (NOT localStorage)
      setPdfValidation({
        isRelevant: validation.isRelevant,
        relevanceScore: validation.relevanceScore,
        fileId: uploadData.fileMetadata.fileId,
        fileName: uploadData.fileMetadata.originalFilename,
        fileSize: uploadData.fileMetadata.fileSizeBytes,
        keyTermsFound: validation.keyTermsFound,
        reasoning: validation.reasoning
      });

      // Show appropriate message based on relevance score
      if (validation.relevanceScore >= 70) {
        showToast(`✅ PDF validated! Relevance: ${validation.relevanceScore}/100 (High)`, 'success');
      } else if (validation.relevanceScore >= 30) {
        showToast(`⚠️ PDF validated. Relevance: ${validation.relevanceScore}/100 (Medium)`, 'warning');
        setShowRelevanceWarning(true);
      } else {
        showToast(`❌ PDF validated. Relevance: ${validation.relevanceScore}/100 (Low)`, 'error');
        setShowRelevanceWarning(true);
      }

    } catch (error) {
      console.error('PDF validation error:', error);
      
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        showToast('Validation timeout. Please try again.', 'error');
      } else if (error.response?.status === 429) {
        showToast('Rate limit exceeded. Please wait and try again.', 'error');
      } else {
        showToast(error.response?.data?.message || 'PDF validation failed', 'error');
      }
      
      setPdfValidation(null);
    } finally {
      setValidatingPdf(false);
    }
  };

  // Flatten the template into an ordered list of leaves. A leaf is the unit that gets
  // variations: a sub-part (3rd level) if the sub-question has parts, else the sub-question,
  // else the question itself when it has no sub-questions.
  const buildLeaves = () => {
    const leaves = [];
    (templateQuestions || []).forEach(q => {
      if (q.sub_questions && q.sub_questions.length > 0) {
        q.sub_questions.forEach(sq => {
          if (sq.has_subquestions && (sq.subquestions || []).length > 0) {
            sq.subquestions.forEach(ssq => leaves.push({ question: q, subQuestion: sq, subPart: ssq }));
          } else {
            leaves.push({ question: q, subQuestion: sq, subPart: null });
          }
        });
      } else {
        leaves.push({ question: q, subQuestion: null, subPart: null });
      }
    });
    return leaves;
  };

  const handleNextQuestion = () => {
    const leaves = buildLeaves();
    if (leaves.length === 0) {
      showToast('No questions available', 'error');
      return;
    }

    const matchesCurrent = (leaf) =>
      leaf.question?.question_number === selectedQuestion?.question_number &&
      (leaf.subQuestion?.sub_number || null) === (selectedSubQuestion?.sub_number || null) &&
      (leaf.subPart?.sub_number || null) === (selectedSubPart?.sub_number || null);

    const currentIndex = selectedQuestion ? leaves.findIndex(matchesCurrent) : -1;
    const nextIndex = currentIndex + 1;

    if (nextIndex >= leaves.length) {
      showToast('No more questions available', 'info');
      return;
    }

    const next = leaves[nextIndex];
    setSelectedQuestion(next.question);
    setSelectedSubQuestion(next.subQuestion);
    setSelectedSubPart(next.subPart);

    const label = next.subPart
      ? `${next.question.question_number}.${next.subQuestion.sub_number}.${next.subPart.sub_number}`
      : next.subQuestion
        ? `${next.question.question_number}.${next.subQuestion.sub_number}`
        : `Question ${next.question.question_number}`;
    showToast(`Moved to ${label}`, 'info');
  };

  const handleGenerateVariations = async () => {
    // Validation
    if (!selectedPool || !selectedQuestion) {
      showToast('Please select a pool and question', 'error');
      return;
    }

    const hasSubQuestions = selectedQuestion.sub_questions?.length > 0;
    if (hasSubQuestions && !selectedSubQuestion) {
      showToast('Please select a sub-question', 'error');
      return;
    }

    const subHasParts = !!(selectedSubQuestion && selectedSubQuestion.has_subquestions && (selectedSubQuestion.subquestions || []).length > 0);
    if (subHasParts && !selectedSubPart) {
      showToast('Please select a sub-part', 'error');
      return;
    }

    if (!paperForm.chapters?.trim()) {
      showToast('Please enter topics/chapters', 'error');
      return;
    }

    if (!variationForm.num_variations || variationForm.num_variations < 4) {
      showToast('Minimum 4 variations required', 'error');
      return;
    }

    // Resolve the leaf (the unit variations are generated for) and its hierarchical number.
    const leaf = !hasSubQuestions ? selectedQuestion : (subHasParts ? selectedSubPart : selectedSubQuestion);
    const leafSubNumber = !hasSubQuestions
      ? 'main'
      : (subHasParts
          ? `${selectedSubQuestion.sub_number}.${selectedSubPart.sub_number}`
          : selectedSubQuestion.sub_number);
    const leafMarks = leaf?.marks || selectedQuestion.marks;
    const leafDifficulty = leaf?.difficulty || 'medium';
    const leafQuestionType = leaf?.question_type || selectedQuestion.question_type;

    try {
      setGenerating(true);
      setShowProgressModal(true);
      setGenerationProgress({ 
        current: 0, 
        total: variationForm.num_variations, 
        stage: 'Starting generation...' 
      });

      // Create main question
      const { data: mainData } = await API.post('/sub-questions/create-main-question', {
        paper_id: selectedPool,
        question_number: selectedQuestion.question_number,
        subject: paperForm.subject,
        topic: paperForm.chapters,
        question_type: selectedQuestion.question_type,
        is_university_pool: true,
        pool_paper_id: selectedPool
      });

      const mainQuestionId = mainData.parent_question_id;

      // Create sub-question (leaf). For a 3rd-level part the leafSubNumber carries the path
      // ("a.i") so the backend links it to its parent sub-question.
      const { data: subData } = await API.post('/sub-questions/create-sub-question', {
        parent_question_id: mainQuestionId,
        paper_id: selectedPool,
        sub_question_number: leafSubNumber,
        question_type: leafQuestionType,
        marks: leafMarks,
        difficulty: leafDifficulty,
        is_university_pool: true,
        pool_paper_id: selectedPool
      });

      const subQuestionId = subData.sub_question_id;

      // Generate variations
      setGenerationProgress({ 
        current: 0, 
        total: variationForm.num_variations, 
        stage: 'Generating variations...' 
      });

      const { data } = await API.post('/sub-questions/generate-variations', {
        sub_question_id: subQuestionId,
        num_variations: variationForm.num_variations,
        subject: paperForm.subject,
        topic: paperForm.chapters,
        chapters: paperForm.chapters,
        language: paperForm.language,
        difficulty: leafDifficulty,
        is_university_pool: true,
        pool_paper_id: selectedPool,
        question_number: selectedQuestion.question_number,
        sub_question_number: leafSubNumber,
        question_type: leafQuestionType,
        marks: leafMarks
      });

      if (data.success) {
        showToast(`Successfully generated ${variationForm.num_variations} variations!`, 'success');
        setTimeout(() => {
          navigate('/examiner/papers');
        }, 1500);
      }
    } catch (error) {
      console.error('Error generating variations:', error);
      showToast(error.response?.data?.message || 'Failed to generate variations', 'error');
    } finally {
      setGenerating(false);
      setShowProgressModal(false);
    }
  };

  return (
    <div style={{ margin: '0 auto', padding: '2rem' }}>
      {/* Header */}
      <div style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        borderRadius: '16px',
        padding: '2.5rem 2rem',
        marginBottom: '2rem',
        boxShadow: '0 10px 40px rgba(102, 126, 234, 0.3)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          <div style={{ fontSize: '3rem' }}>🎓</div>
          <div>
            <h1 style={{ margin: 0, fontSize: '2rem', fontWeight: '800', color: '#fff' }}>
              Generate Questions for University Pool
            </h1>
            <p style={{ margin: '0.5rem 0 0 0', color: 'rgba(255,255,255,0.9)' }}>
              Contribute question variations to university-wide pools
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div style={{
        background: 'var(--bg-primary)',
        borderRadius: '16px',
        boxShadow: 'var(--shadow-lg)',
        border: '1px solid var(--border-color)',
        overflow: 'hidden'
      }}>
        {/* Step 1: Pool Selection */}
        <div style={{ padding: '2rem', borderBottom: '1px solid var(--border-color)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
            <div style={{
              width: '40px',
              height: '40px',
              borderRadius: '10px',
              background: 'linear-gradient(135deg, #667eea, #764ba2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.25rem',
              color: '#fff',
              fontWeight: '700'
            }}>1</div>
            <div>
              <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)' }}>
                Select University Pool
              </h3>
              <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                Choose a pool paper created by your university
              </p>
            </div>
          </div>

          <div style={{ maxWidth: '700px' }}>
            <label style={{
              display: 'block',
              marginBottom: '0.75rem',
              fontSize: '0.875rem',
              fontWeight: '600',
              color: 'var(--text-primary)'
            }}>
              Available Pools *
            </label>
            <select
              className="form-select"
              value={selectedPool || ''}
              onChange={(e) => {
                const poolId = e.target.value;
                if (poolId) {
                  handlePoolSelect(parseInt(poolId));
                } else {
                  setSelectedPool(null);
                  setTemplateQuestions([]);
                  setSelectedQuestion(null);
                  setSelectedSubQuestion(null);
                  setPaperForm({
                    subject: '',
                    topic: '',
                    chapters: '',
                    language: 'english'
                  });
                }
              }}
              style={{
                fontSize: '1rem',
                padding: '0.875rem 1rem',
                borderRadius: '10px',
                border: `2px solid ${selectedPool ? 'var(--success)' : 'var(--border-color)'}`,
                background: selectedPool ? 'var(--success-light)' : 'var(--bg-secondary)',
                width: '100%'
              }}
            >
              <option value="">-- Select University Pool --</option>
              {universityPools.map(pool => (
                <option key={pool.pool_paper_id} value={pool.pool_paper_id}>
                  {pool.subject_name} - {pool.paper_title}
                </option>
              ))}
            </select>

            {universityPools.length === 0 && (
              <div style={{
                marginTop: '1rem',
                padding: '1rem',
                background: 'var(--warning-light)',
                borderRadius: '8px',
                border: '1px solid var(--warning)',
                fontSize: '0.875rem',
                color: 'var(--warning)'
              }}>
                ⚠️ No active university pools available
              </div>
            )}
          </div>
        </div>

        {/* Step 2: Question Selection */}
        {selectedPool && templateQuestions.length > 0 && (
          <div style={{ padding: '2rem', borderBottom: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.25rem',
                color: '#fff',
                fontWeight: '700'
              }}>2</div>
              <div>
                <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)' }}>
                  Select Question
                </h3>
                <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                  Choose which question to generate variations for
                </p>
              </div>
            </div>

            <div style={{ maxWidth: '700px' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.75rem',
                fontSize: '0.875rem',
                fontWeight: '600',
                color: 'var(--text-primary)'
              }}>
                Questions *
              </label>
              <select
                className="form-select"
                value={selectedQuestion?.question_number || ''}
                onChange={(e) => {
                  const question = templateQuestions.find(q => q.question_number === e.target.value);
                  setSelectedQuestion(question);
                  setSelectedSubQuestion(null);
                  setSelectedSubPart(null);
                }}
                style={{
                  fontSize: '1rem',
                  padding: '0.875rem 1rem',
                  borderRadius: '10px',
                  border: `2px solid ${selectedQuestion ? 'var(--success)' : 'var(--border-color)'}`,
                  background: selectedQuestion ? 'var(--success-light)' : 'var(--bg-secondary)',
                  width: '100%'
                }}
              >
                <option value="">-- Select Question --</option>
                {templateQuestions.map(q => (
                  <option key={q.question_number} value={q.question_number}>
                    {q.question_number} ({q.question_type}, {q.marks} marks)
                    {q.sub_questions?.length > 0 ? ` - ${q.sub_questions.length} sub-questions` : ''}
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* Step 3: Sub-Question Selection */}
        {selectedQuestion && selectedQuestion.sub_questions?.length > 0 && (
          <div style={{ padding: '2rem', borderBottom: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.25rem',
                color: '#fff',
                fontWeight: '700'
              }}>3</div>
              <div>
                <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)' }}>
                  Select Sub-Question
                </h3>
              </div>
            </div>

            <div style={{ maxWidth: '700px' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.75rem',
                fontSize: '0.875rem',
                fontWeight: '600',
                color: 'var(--text-primary)'
              }}>
                Sub-Questions *
              </label>
              <select
                className="form-select"
                value={selectedSubQuestion?.sub_number || ''}
                onChange={(e) => {
                  const subQuestion = selectedQuestion.sub_questions.find(sq => sq.sub_number === e.target.value);
                  setSelectedSubQuestion(subQuestion);
                  setSelectedSubPart(null);
                }}
                style={{
                  fontSize: '1rem',
                  padding: '0.875rem 1rem',
                  borderRadius: '10px',
                  border: `2px solid ${selectedSubQuestion ? 'var(--success)' : 'var(--border-color)'}`,
                  background: selectedSubQuestion ? 'var(--success-light)' : 'var(--bg-secondary)',
                  width: '100%'
                }}
              >
                <option value="">-- Select Sub-Question --</option>
                {selectedQuestion.sub_questions.map((sq, index) => (
                  <option key={index} value={sq.sub_number}>
                    Sub-{sq.sub_number} ({sq.question_type || selectedQuestion.question_type}, {sq.marks} marks)
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* Step 3b: Sub-Part Selection (3rd level) */}
        {selectedSubQuestion && selectedSubQuestion.has_subquestions && selectedSubQuestion.subquestions?.length > 0 && (
          <div style={{ padding: '2rem', borderBottom: '1px solid var(--border-color)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1rem',
                color: '#fff',
                fontWeight: '700'
              }}>3b</div>
              <div>
                <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)' }}>
                  Select Sub-Part
                </h3>
                <p style={{ margin: '0.25rem 0 0 0', fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                  This sub-question has sub-parts. Choose the sub-part to generate variations for.
                </p>
              </div>
            </div>

            <div style={{ maxWidth: '700px' }}>
              <label style={{
                display: 'block',
                marginBottom: '0.75rem',
                fontSize: '0.875rem',
                fontWeight: '600',
                color: 'var(--text-primary)'
              }}>
                Sub-Parts *
              </label>
              <select
                className="form-select"
                value={selectedSubPart?.sub_number || ''}
                onChange={(e) => {
                  const subPart = selectedSubQuestion.subquestions.find(ssq => ssq.sub_number === e.target.value);
                  setSelectedSubPart(subPart);
                }}
                style={{
                  fontSize: '1rem',
                  padding: '0.875rem 1rem',
                  borderRadius: '10px',
                  border: `2px solid ${selectedSubPart ? 'var(--success)' : 'var(--border-color)'}`,
                  background: selectedSubPart ? 'var(--success-light)' : 'var(--bg-secondary)',
                  width: '100%'
                }}
              >
                <option value="">-- Select Sub-Part --</option>
                {selectedSubQuestion.subquestions.map((ssq, index) => (
                  <option key={index} value={ssq.sub_number}>
                    {selectedQuestion.question_number}.{selectedSubQuestion.sub_number}.{ssq.sub_number} ({ssq.question_type || selectedSubQuestion.question_type}, {ssq.marks} marks)
                  </option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* Step 4: Generation Details */}
        {selectedQuestion && (!selectedQuestion.sub_questions?.length || (selectedSubQuestion && (!(selectedSubQuestion.has_subquestions && selectedSubQuestion.subquestions?.length > 0) || selectedSubPart))) && (
          <div style={{ padding: '2rem' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.5rem' }}>
              <div style={{
                width: '40px',
                height: '40px',
                borderRadius: '10px',
                background: 'linear-gradient(135deg, #667eea, #764ba2)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.25rem',
                color: '#fff',
                fontWeight: '700'
              }}>4</div>
              <div>
                <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)' }}>
                  Generation Details
                </h3>
              </div>
            </div>

            <div style={{ maxWidth: '700px', display: 'grid', gap: '1.5rem' }}>
              {/* Subject - Pre-filled */}
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Subject (Pre-filled from Pool)
                </label>
                <input
                  type="text"
                  value={paperForm.subject}
                  disabled
                  style={{
                    fontSize: '1rem',
                    padding: '0.875rem 1rem',
                    borderRadius: '10px',
                    border: '2px solid var(--border-color)',
                    background: 'var(--bg-secondary)',
                    width: '100%',
                    opacity: 0.7,
                    color: 'var(--text-primary)'

                  }}
                />
              </div>

              {/* Topics/Chapters */}
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Topics/Chapters *
                </label>
                <textarea
                  value={paperForm.chapters}
                  onChange={(e) => setPaperForm(prev => ({ ...prev, chapters: e.target.value }))}
                  placeholder="e.g., Calculus, Derivatives, Integration"
                  rows="3"
                  style={{
                    fontSize: '1rem',
                    padding: '0.875rem 1rem',
                    color: 'var(--text-primary)',
                    borderRadius: '10px',
                    border: '2px solid var(--border-color)',
                    background: 'var(--bg-secondary)',
                    width: '100%',
                    resize: 'vertical'
                  }}
                />
              </div>

              {/* Language Selection */}
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Language
                </label>
                <select
                  value={paperForm.language}
                  onChange={(e) => setPaperForm(prev => ({ ...prev, language: e.target.value }))}
                  style={{
                    fontSize: '1rem',
                    padding: '0.875rem 1rem',
                    borderRadius: '10px',
                    border: '2px solid var(--border-color)',
                    background: 'var(--bg-secondary)',
                    width: '100%',
                    color: 'var(--text-primary)'

                  }}
                >
                  <option value="english">English</option>
                  <option value="hindi">Hindi</option>
                  <option value="marathi">Marathi</option>
                  <option value="urdu">Urdu</option>
                </select>
              </div>

              {/* PDF Upload (Optional) */}
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Reference PDF (Optional)
                  <span style={{
                    fontSize: '0.75rem',
                    color: 'var(--text-secondary)',
                    fontWeight: '400',
                    marginLeft: '0.5rem'
                  }}>
                    - Upload study material for context-aware questions
                  </span>
                </label>
                {!pdfFile ? (
                  <div
                    style={{
                      border: '2px dashed var(--border-color)',
                      borderRadius: '10px',
                      padding: '2rem',
                      textAlign: 'center',
                      background: 'var(--bg-secondary)',
                      cursor: 'pointer',
                      transition: 'all 0.2s'
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = 'var(--primary)';
                      e.currentTarget.style.background = 'var(--primary-light)';
                    }}
                    onDragLeave={(e) => {
                      e.currentTarget.style.borderColor = 'var(--border-color)';
                      e.currentTarget.style.background = 'var(--bg-secondary)';
                    }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = 'var(--border-color)';
                      e.currentTarget.style.background = 'var(--bg-secondary)';
                      const file = e.dataTransfer.files[0];
                      if (file) {
                        handlePdfSelect({ target: { files: [file] } });
                      }
                    }}
                    onClick={() => document.getElementById('pdf-upload-input').click()}
                  >
                    <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📄</div>
                    <div style={{ color: 'var(--text-primary)', marginBottom: '0.25rem' }}>
                      Click to upload or drag and drop
                    </div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                      PDF files only (max 10MB)
                    </div>
                    <input
                      id="pdf-upload-input"
                      type="file"
                      accept="application/pdf"
                      onChange={handlePdfSelect}
                      style={{ display: 'none' }}
                    />
                  </div>
                ) : (
                  <div
                    style={{
                      border: '2px solid var(--success)',
                      borderRadius: '10px',
                      padding: '1rem',
                      background: 'var(--success-light)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between'
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                      <div style={{ fontSize: '1.5rem' }}>📄</div>
                      <div>
                        <div style={{ fontWeight: '500', color: 'var(--text-primary)' }}>
                          {pdfFile.name}
                        </div>
                        <div style={{ fontSize: '0.875rem', color: 'var(--text-secondary)' }}>
                          {(pdfFile.size / 1024 / 1024).toFixed(2)} MB
                        </div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '0.5rem' }}>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={handleValidatePdf}
                        disabled={validatingPdf}
                        style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                      >
                        {validatingPdf ? 'Validating...' : 'Validate'}
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={handlePdfRemove}
                        style={{ padding: '0.5rem 1rem', fontSize: '0.875rem' }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                )}

                {/* Validation Button - Only show when PDF is uploaded but not validated */}
                {pdfFile && !pdfValidation && !validatingPdf && (
                  <button
                    onClick={handleValidatePdf}
                    disabled={!paperForm.topic || !paperForm.subject}
                    style={{
                      marginTop: '0.75rem',
                      width: '100%',
                      padding: '0.75rem',
                      borderRadius: '8px',
                      border: 'none',
                      background: (!paperForm.topic || !paperForm.subject)
                        ? 'var(--bg-secondary)'
                        : 'var(--primary)',
                      color: (!paperForm.topic || !paperForm.subject)
                        ? 'var(--text-secondary)'
                        : 'white',
                      cursor: (!paperForm.topic || !paperForm.subject)
                        ? 'not-allowed'
                        : 'pointer',
                      fontSize: '0.875rem',
                      fontWeight: '600',
                      transition: 'all 0.2s'
                    }}
                  >
                    ✅ Validate Topic with PDF
                  </button>
                )}

                {validatingPdf && (
                  <div
                    style={{
                      marginTop: '0.75rem',
                      padding: '0.75rem',
                      borderRadius: '8px',
                      background: 'var(--info-light)',
                      color: 'var(--info)',
                      fontSize: '0.875rem',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem'
                    }}
                  >
                    <div className="spinner-border spinner-border-sm" role="status"></div>
                    Uploading PDF to File Search Store...
                  </div>
                )}

                {pdfValidation && pdfValidation.fileId && (
                  <div
                    style={{
                      marginTop: '0.75rem',
                      padding: '0.75rem',
                      borderRadius: '8px',
                      background:
                        pdfValidation.relevanceScore >= 70
                          ? 'var(--success-light)'
                          : pdfValidation.relevanceScore >= 30
                          ? 'var(--warning-light)'
                          : 'rgba(220, 53, 69, 0.1)',
                      color:
                        pdfValidation.relevanceScore >= 70
                          ? 'var(--success)'
                          : pdfValidation.relevanceScore >= 30
                          ? 'var(--warning)'
                          : '#dc3545',
                      fontSize: '0.875rem',
                      border: `1px solid ${
                        pdfValidation.relevanceScore >= 70
                          ? 'var(--success)'
                          : pdfValidation.relevanceScore >= 30
                          ? 'var(--warning)'
                          : '#dc3545'
                      }`
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        marginBottom: '0.5rem'
                      }}
                    >
                      <span style={{ fontSize: '1.25rem' }}>
                        {pdfValidation.relevanceScore >= 70
                          ? '✅'
                          : pdfValidation.relevanceScore >= 30
                          ? '⚠️'
                          : '❌'}
                      </span>
                      <div style={{ fontWeight: '600' }}>
                        {pdfValidation.relevanceScore >= 70
                          ? 'PDF validated (High relevance)'
                          : pdfValidation.relevanceScore >= 30
                          ? 'PDF validated (Medium relevance)'
                          : 'PDF validated (Low relevance)'}
                      </div>
                    </div>
                    <div
                      style={{
                        fontSize: '0.75rem',
                        opacity: 0.9,
                        marginLeft: '2rem'
                      }}
                    >
                      <div>Relevance: {pdfValidation.relevanceScore}/100</div>
                      <div>File ID: {pdfValidation.fileId.substring(0, 20)}...</div>
                      {pdfValidation.reasoning && (
                        <div style={{ marginTop: '0.5rem', fontStyle: 'italic' }}>
                          {pdfValidation.reasoning}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* Number of Variations */}
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '0.75rem',
                  fontSize: '0.875rem',
                  fontWeight: '600',
                  color: 'var(--text-primary)'
                }}>
                  Number of Variations *
                </label>
                <input
                  type="number"
                  value={variationForm.num_variations}
                  onChange={(e) => setVariationForm({ ...variationForm, num_variations: parseInt(e.target.value) || 4 })}
                  min="4"
                  max="200"
                  style={{
                    fontSize: '1rem',
                    padding: '0.875rem 1rem',
                    borderRadius: '10px',
                    border: '2px solid var(--border-color)',
                    background: 'var(--bg-secondary)',
                    width: '100%',
                    color: 'var(--text-primary)'
                  }}
                />
                <div style={{ marginTop: '0.5rem', fontSize: '0.75rem', color: 'var(--text-secondary)' }}>
                  Minimum 4 variations required
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '2rem' }}>
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setSelectedPool(null);
                  setPoolDetails(null);
                  setTemplateQuestions([]);
                  setSelectedQuestion(null);
                  setSelectedSubQuestion(null);
                  setPaperForm({
                    subject: '',
                    topic: '',
                    chapters: '',
                    language: 'english'
                  });
                  setVariationForm({ num_variations: 4 });
                  setPdfFile(null);
                  setPdfValidation(null);
                }}
                style={{ padding: '1rem 2rem', fontSize: '1rem' }}
              >
                Reset
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleNextQuestion}
                disabled={!selectedQuestion || !templateQuestions || templateQuestions.length === 0}
                style={{ padding: '1rem 2rem', fontSize: '1rem' }}
              >
                ➡️ Next Question
              </button>
              <button
                className="btn btn-primary"
                onClick={handleGenerateVariations}
                disabled={
                  generating ||
                  !selectedPool ||
                  !selectedQuestion ||
                  (selectedQuestion.sub_questions?.length > 0 && !selectedSubQuestion) ||
                  (selectedSubQuestion?.has_subquestions && selectedSubQuestion?.subquestions?.length > 0 && !selectedSubPart) ||
                  !paperForm.chapters ||
                  variationForm.num_variations < 4
                }
                style={{
                  padding: '1rem 2rem',
                  fontSize: '1rem',
                  opacity: (
                    generating || 
                    !selectedPool || 
                    !selectedQuestion || 
                    (selectedQuestion.sub_questions?.length > 0 && !selectedSubQuestion) ||
                    !paperForm.chapters || 
                    variationForm.num_variations < 4
                  ) ? 0.6 : 1
                }}
              >
                {generating ? 'Generating...' : '🏛️ Generate for University Pool'}
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Progress Modal */}
      {showProgressModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.8)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999
        }}>
          <div style={{
            background: 'var(--bg-primary)',
            borderRadius: '1rem',
            padding: '3rem',
            maxWidth: '500px',
            textAlign: 'center',
            boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
            border: '1px solid var(--border-color)'
          }}>
            <div style={{
              width: '80px',
              height: '80px',
              margin: '0 auto 2rem',
              border: '4px solid var(--primary-light)',
              borderTop: '4px solid var(--primary)',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }}></div>
            <h3 style={{ margin: '0 0 1rem 0', color: 'var(--primary)', fontSize: '1.5rem' }}>
              Generating Variations
            </h3>
            <p style={{ margin: 0, fontSize: '1.125rem', color: 'var(--text-primary)', fontWeight: '500' }}>
              {generationProgress.stage}
            </p>
          </div>
        </div>
      )}

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default UniversityQuestionGeneration;
